import React, {useContext, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import store from "@formApp/store";
import {getTlds} from "@formApp/utils";
import DomainSearch from "@formComponents/fields/DomainSearch";
import SingleDomainItem from "@formComponents/SingleDomainItem";
import Spinner from "@formComponents/Spinner";

export default () => {
  const {domainsList, formValues} = useContext(store);
  const [searchIsEmpty, setSearchIsEmpty] = useState(false);

  const {t} = useTranslation();
  const moreResultsRef = useRef(null);

  useEffect(() => {
    getTlds().then(res => {
      if (!res.success) return;
      domainsList.setCurrentPrimaryTld(res.primary);
      domainsList.setCurrentSecondaryTld(res.secondary);
    });
  }, []);

  useEffect(() => {
    if (!domainsList.list.length) return;
    if (domainsList.secondaryList.length) return; // bail early if secondarylist is alreaady populated
    const availableResults = domainsList.list.filter(item => item.isAvailable);
    if (availableResults.length < 2) lookForMore();
  }, [domainsList]);

  useEffect(() => {
    const {list, secondaryList, thirdLevel, searchState, secondarySearchState} = domainsList;
    if (searchState === 'finished' && secondarySearchState === 'finished') {
      if (thirdLevel && thirdLevel.isAvailable === false) {
        let availableResults = list.filter(item => item.isAvailable);
        if (availableResults.length === 0) {
          availableResults = secondaryList.filter(item => item.isAvailable);
          if (availableResults.length === 0) {
            setSearchIsEmpty(true);
          }
        }
      }
    } else {
      setSearchIsEmpty(false);
    }
    if (list.length && searchState === 'finished' && secondarySearchState === (list.filter(_ => _.isAvailable).length < 2 ? 'finished' : 'idle')) {
      const {requestedTld, groupDomain, primaryTld, secondaryTld} = domainsList;
      const choosenTld = requestedTld === groupDomain ? null : requestedTld;
      const choosenTldNoDot = choosenTld?.slice(1);
      // FIXME this is triggered twice, but it shouldn't
      dataLayer.push({
        event: 'list_results',
        eventCategory: 'Domain search',
        eventAction: 'results',
        eventLabel: choosenTld ? requestedTld : 'no choose',
        available: choosenTld ? [...list, ...secondaryList].find(_ => _.domain === choosenTld)?.isAvailable ?? false : 'no choose',
        viewable: choosenTld ? [...primaryTld, ...secondaryTld].some(_ => _.name === choosenTldNoDot) : 'no choose',
      });
    }
  }, [domainsList.searchState, domainsList.secondarySearchState]);
  
  const lookForMore = async () => {

    var newDomainList = domainsList.secondaryTld;

    if (domainsList.domainExactMatchTld.length) {
      var matchTld = domainsList.domainExactMatchTld[0].domain.replace('.','');
      newDomainList = domainsList.secondaryTld.filter(domain => domain.name != matchTld);
    }

    const siteName = formValues.getValue('siteName');
    domainsList.setSecondarySearch('started');

    const res = await Promise.allSettled(
      newDomainList.map( async tld => {
        const response = await fetch(`https://aa.altervista.org/ajax-domain.php?action=lookup&domain=${siteName}&tld=${tld.name}`);
        const data = await response.json();
        if (data.success) {
          const entry = {
            name: siteName,
            domain: `.${tld.name}`,
            isAvailable: data.available,
            finalPrice: tld.finalPrice,
            price: tld.price
          };
          if (data.available) {
            domainsList.addToHead2(entry);
          } else {
            domainsList.addToTail2(entry)
          }
        }
        return data;
      })
    );
    domainsList.setSecondarySearch('finished');
    window.scrollTo({
      top: moreResultsRef.current.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
  };
  const resetForm = () => {
    domainsList.clear();
    domainsList.clear2();
    domainsList.setSearch('idle');
    domainsList.setSecondarySearch('idle');
    setSearchIsEmpty(false);
  };
  return (
    <>
      <header className="form-heading">
        <h2>{t('Scegli il nome del tuo sito')}</h2>
      </header>
      <Formik
        initialValues={{siteName: ''}}
        validationSchema={Yup.object({
          siteName: Yup.string()
            .max(63, t('Il nome del sito web non è valido, deve essere massimo 63 caratteri'))// todo: controllare max num di caratteri
            .matches(/^[a-z]/i, t('Il nome del sito web non è valido, deve cominciare con una lettera'))
            .matches(/^[a-zA-Z0-9-.]+$/, t('Il nome del sito web non è valido, deve contenere solo numeri e lettere non accentate'))
            .required(t('Il nome del dominio è obbligatorio'))
        })}
        onSubmit={(values, { setSubmitting }) => {
          formValues.set(values);
          setSubmitting(false);
        }}
      >
        <Form className='domainSearch'>
          <Field name='siteName' component={DomainSearch} step={1} />
          <div className="transitionWrapper">

            {(domainsList.searchState === 'finished' || domainsList.searchState === 'started')
              ? null
              : <div className="domainsList"><p className='tld-info' dangerouslySetInnerHTML={{__html: t('tld-info-placeholder')}} /></div>
            }

            {domainsList.domainExactMatchTld && (
            <div className="domainsList">
              <div className="toTransition">
                <TransitionGroup>
                  {domainsList.domainExactMatchTld.map( (item, n) => (
                    <CSSTransition
                      key={item.domain}
                      timeout={100}
                      classNames="domainsList--item"
                    >
                      <SingleDomainItem key={item.domain} item={item} step={1} />
                    </CSSTransition>
                  ))}
                </TransitionGroup>
              </div>            
            </div>
            )}   

            {domainsList.thirdLevel && (
            <div className="domainsList">
              <div className="toTransition">
                <CSSTransition
                  in={domainsList.searchState === 'finished'}
                  key='altervista'
                  timeout={150}
                  classNames="altervista--item"
                  appear={false}
                >
                  <>
                  {(domainsList.searchState === 'finished') && <SingleDomainItem key='altervista' item={domainsList.thirdLevel} step={1} />}
                  </>
                </CSSTransition>
              </div>
            </div>
            )}
            
            <div className={`domainsList`}>
              <div className="toTransition">
                <TransitionGroup className="mobile-full-width">
                {domainsList.list.map( (item, n) => (
                  <CSSTransition
                    key={item.domain}
                    timeout={100}
                    classNames="domainsList--item"
                  >
                    <SingleDomainItem key={item.domain} item={item} step={1} />
                  </CSSTransition>
                ))}
                </TransitionGroup>
              </div>
              <Spinner isVisible={domainsList.searchState === 'started'} style={{marginTop: '30px'}} />
            </div>
            <div ref={moreResultsRef} className={`domainsList secondarySearchSlot ${domainsList.secondarySearchState}`}>
              <div className="toTransition">
                <TransitionGroup className="mobile-full-width">
                  {domainsList.secondaryList.map( (item, n) => (
                    <CSSTransition
                      key={item.domain}
                      timeout={100}
                      classNames="domainsList--item"
                    >
                      <SingleDomainItem key={item.domain} item={item} step={1} />
                    </CSSTransition>
                  ))}
                </TransitionGroup>
              </div>
              <Spinner isVisible={domainsList.secondarySearchState === 'started'} style={{marginTop: '30px'}} />
              {domainsList.secondarySearchState === 'idle' && domainsList.searchState === 'finished' &&
                <button className="secondarySearch--button" type='button' onClick={lookForMore}>{t('Altri domini disponibili')}</button>
              }
              {searchIsEmpty && <button className="secondarySearch--button" type='button' onClick={resetForm}>{t("Non abbiamo trovato domini disponibili, riprova")}</button>}
            </div>
          </div>
        </Form>
      </Formik>
    </>
  )
}